import { useMemo, useState } from "react";

import type { ChatStory } from "../types";

export function useFilePreview({ rawMessages }: { rawMessages: ChatStory[] }): {
  attachmentList: ChatStory[];
  currentAttachmentId: null | number;
  handleClosePreview: () => void;
  handleOpenPreview: (attachmentId: number) => void;
  selectedAttachment: ChatStory | undefined;
} {
  const [currentAttachmentId, setCurrentAttachmentId] = useState<null | number>(
    null,
  );

  const attachmentList = useMemo(
    () =>
      rawMessages.filter(
        (message) => message.asanaResourceType === "attachment",
      ),
    [rawMessages],
  );

  const selectedAttachment = useMemo(
    () =>
      rawMessages.find(
        (message) => message.attachmentId === currentAttachmentId,
      ),
    [rawMessages, currentAttachmentId],
  );

  const handleOpenPreview = (attachmentId: number) => {
    setCurrentAttachmentId(attachmentId);
  };

  const handleClosePreview = () => {
    setCurrentAttachmentId(null);
  };

  return {
    attachmentList,
    currentAttachmentId,
    handleClosePreview,
    handleOpenPreview,
    selectedAttachment,
  };
}
